import AxiosInstance from 'config/apiServiceApiGateway'

export interface SendVendorEmailRequestInterface {
  id: number
  name: string
  email: string
  phone_number: string
  role_id: number
  is_resend_email: boolean
  vendor_id: number
}

export interface VendorAccountInterface {
  id: number
  name: string
  email: string
  verified: boolean
  status: string
  phone_number: string
  role: string
  role_id: number
  role_name: string
  role_tier?: string
  can_resend_email: boolean
  active: boolean
}

export interface VendorRoleInterface {
  id: number
  name: string
  label: string
  tier?: string
}

export const fetchVendorRolesApi = () =>
  AxiosInstance.Get<{ data: { roles: VendorRoleInterface[] } }, true>({
    url: 'auth/internal/:version/role/vendor/list',
    version: 'v1',
  })

export const fetchVendorAccountsApi = (vendorId: string) =>
  AxiosInstance.Get<{ data: { users: VendorAccountInterface[] } }, true>({
    url: '/accounts/internal/:version/user/vendor-id/:vendorId',
    version: 'v1',
    urlParams: { vendorId },
  })

export const postSendVendorEmailApi = (data: SendVendorEmailRequestInterface) =>
  AxiosInstance.Post({
    url: '/accounts/internal/:version/user/vendor/upsert',
    version: 'v1',
    data,
  })

export const getVendorRolesApi = () =>
  AxiosInstance.Get({
    url: '/commercial/internal/:version/roles',
    version: 'v1',
  })

export const deleteVendorAccountApi = (id: number) =>
  AxiosInstance.Delete({
    url: '/accounts/internal/:version/user/vendor/:id',
    version: 'v1',
    urlParams: { id },
  })
